import type { DealOffer, DealOfferFormatOption } from "@/components/marketplace/deal-offers-types";
import { sortOffersByTotal } from "@/components/marketplace/offer-list-summary";
import { FORMAT_CATEGORIES_WITH_OTHER } from "@garimpa/lib/formatGroups";

export function getDealOfferExplorerFormatOptions(offers: DealOffer[]): DealOfferFormatOption[] {
  return FORMAT_CATEGORIES_WITH_OTHER.flatMap((format) => {
    const matching = sortOffersByTotal(offers.filter((offer) => offer.formatCategory === format));
    const cheapest = matching[0];
    return cheapest
      ? [
          {
            availability: "available",
            format,
            offerCount: matching.length,
            price: cheapest.currentPriceTotal ?? cheapest.currentPrice,
            currency: cheapest.currentCurrency,
          },
        ]
      : [];
  });
}
